// extracted by mini-css-extract-plugin
export default {"contentChat":"Messages_contentChat__2z4Ci","scrollbar":"Messages_scrollbar__jnxXO","own":"Messages_own__YCQAU","chat":"Messages_chat__sS-Ut","loading":"Messages_loading__RCbGC"};